export enum EndUserType {
  USER = 'USER',
  VISITOR = 'VISITOR',
  API_CLIENT = 'API_CLIENT',
}
